import React from "react";

const MiddleEastWarImpact = () => {
  return (
    <div style={{ background: '#f8fafb', minHeight: '100vh', padding: '10px 16px' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <article style={{ background: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)' }}>
          <div style={{ background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)', color: '#fff', padding: '12px 32px 10px 32px', textAlign: 'center' }}>
            <h1 style={{ margin: '0 0 8px 0', fontSize: '1.5rem', fontWeight: 500, lineHeight: 1.25, letterSpacing: '-0.5px' }}>
              Middle East Conflict Sends Shockwaves Across Asian Markets
            </h1>
            <p style={{ margin: '0', fontSize: '0.98rem', opacity: 0.95, fontWeight: 400 }}>March 22, 2026 | 4 min read</p>
          </div>

          <div style={{ padding: '14px 32px 32px 32px', marginTop: '6px' }}>
            <p style={{ fontSize: '1.05rem', lineHeight: 1.5, color: '#333', marginBottom: '20px', fontWeight: 425, backgroundColor: '#f0f4ff', padding: '20px 24px', borderRadius: '8px', borderLeft: '4px solid #1976d2' }}>
              Rising geopolitical tensions are triggering oil price surges, market volatility,
              and economic uncertainty across Asia. Investors are turning cautious while
              governments and businesses prepare for sustained external pressure.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#1976d2', marginTop: '30px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #e3f2fd' }}>
              Oil Prices Surge and Inflation Risk Climbs
            </h2>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.5, color: '#555', marginBottom: '16px' }}>
              Crude oil prices have jumped as supply concerns intensify around key Middle East
              energy routes. Since the region is central to global oil distribution, disruptions
              quickly translate into higher fuel and transport costs worldwide.
            </p>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.5, color: '#555', marginBottom: '26px' }}>
              Import-dependent economies such as India, Japan, and South Korea face elevated
              inflation risk, which can reduce household purchasing power and increase pressure
              on fiscal and monetary policy.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#1976d2', marginTop: '30px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #e3f2fd' }}>
              Stock Market Volatility Across Asian Sectors
            </h2>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.5, color: '#555', marginBottom: '16px' }}>
              Asian equity markets have reacted unevenly. Aviation, logistics, and finance face
              downside pressure while selective energy-linked counters gain from higher commodity
              prices.
            </p>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.5, color: '#555', marginBottom: '26px' }}>
              Defensive positioning is increasing, with investors moving toward lower-risk assets
              as uncertainty around growth and margins widens.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#1976d2', marginTop: '30px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #e3f2fd' }}>
              Currency and Capital Flow Pressures
            </h2>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.5, color: '#555', marginBottom: '16px' }}>
              Risk-off behavior can weaken emerging Asian currencies as capital rotates toward
              safe-haven markets. A weaker local currency raises import bills and can amplify
              inflationary stress.
            </p>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.5, color: '#555', marginBottom: '26px' }}>
              Central banks may be forced to rebalance policy between growth support and inflation
              control if external pressures stay elevated.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#1976d2', marginTop: '30px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #e3f2fd' }}>
              Supply Chain Disruptions and Trade Friction
            </h2>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.5, color: '#555', marginBottom: '16px' }}>
              Major shipping lanes linked to the Middle East are critical for global merchandise
              flow. Disruptions can drive up freight costs, delay inventory cycles, and reduce
              planning visibility for importers and exporters.
            </p>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.5, color: '#555', marginBottom: '26px' }}>
              Manufacturing-heavy Asian economies remain particularly exposed where production
              timelines depend on just-in-time shipping reliability.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#1976d2', marginTop: '30px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #e3f2fd' }}>
              Safe-Haven Assets Gain Attention
            </h2>
            <ul style={{ fontSize: '1.0rem', lineHeight: 1.35, color: '#555', marginBottom: '26px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '8px' }}>Increased allocation to gold and defensive assets</li>
              <li style={{ marginBottom: '8px' }}>Reduced risk appetite in cyclical sectors</li>
              <li style={{ marginBottom: '8px' }}>Higher preference for liquidity and capital preservation</li>
              <li style={{ marginBottom: '8px' }}>Greater hedging activity against commodity shocks</li>
            </ul>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#1976d2', marginTop: '30px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #e3f2fd' }}>
              Conclusion
            </h2>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.5, color: '#555', marginBottom: '28px', backgroundColor: '#fff3e0', padding: '20px 24px', borderRadius: '8px', borderLeft: '4px solid #ff9800' }}>
              If tensions persist, Asian markets could face prolonged pressure from high energy
              costs, currency volatility, and trade disruptions. Policymakers and businesses will
              need stronger resilience strategies, tighter cost controls, and diversified supply
              networks to navigate an extended risk cycle.
            </p>

            <div style={{ borderTop: '1px solid #e3f2fd', paddingTop: '20px', marginTop: '32px' }}>
              <p style={{ fontSize: '0.75rem', color: '#888', fontStyle: 'italic', margin: '0' }}>
                Article by <strong>Mangalorehub.com Current Affairs Desk</strong>
              </p>
            </div>
          </div>
        </article>
      </div>

    </div>
  );
};

export default MiddleEastWarImpact;